import React, { createContext, useContext, useMemo } from 'react';

const mockUser = {
  sub: 'dev|test-user-123',
  email: 'helena@hypseya.com',
  name: 'Helena',
  picture: null,
  email_verified: true,
};

// Pre-populate localStorage so pages that check it directly work in dev
const mockUserBackend = {
  user_id: 'dev|test-user-123',
  email: 'helena@hypseya.com',
  name: 'Helena',
  has_completed_onboarding: true,
  profile_complete: true,
  expanded_states: 'yes',
  microdosing_practice: 'psilocybin',
};
localStorage.setItem('user', JSON.stringify(mockUserBackend));
localStorage.setItem('userEmail', mockUserBackend.email);

const MockAuth0Context = createContext({
  isAuthenticated: true,
  isLoading: false,
  user: mockUser,
  loginWithRedirect: async () => {},
  logout: () => {},
  getAccessTokenSilently: async () => 'mock-token-dev',
});

export function MockAuth0Provider({ children }) {
  const value = useMemo(() => ({
    isAuthenticated: true,
    isLoading: false,
    user: mockUser,
    loginWithRedirect: async () => {},
    logout: () => { window.location.href = '/'; },
    getAccessTokenSilently: async () => 'mock-token-dev',
  }), []);

  return (
    <MockAuth0Context.Provider value={value}>
      {children}
    </MockAuth0Context.Provider>
  );
}

// Override the real useAuth0 hook
export function useAuth0() {
  return useContext(MockAuth0Context);
}
